module.exports = __webpack_public_path__ + "img/ios-safari.1d4ab080.svg";